var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReduser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10114_14303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.4234 18.2018C58.4234 27.3196 51.1902 34.9761 41.5195 34.9761C32.3294 34.9761 24.5766 27.3196 24.5766 18.2018C24.5766 8.60916 32.3294 1.4259 41.5195 1.4259C51.1902 1.4259 58.4234 8.60916 58.4234 18.2018ZM70.5317 82.4612C72.4496 82.4612 73.4078 81.0401 73.4078 79.5803V54.1598C73.4078 47.4498 68.0942 42.161 61.34 42.161H22.1796C15.3865 42.161 9.59219 47.4498 9.59219 54.1598V79.5803C9.59219 81.0401 11.0307 82.4612 12.5092 82.4612H70.5317Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4617 53.2958C56.1136 53.2725 55.7729 53.4076 55.5321 53.6642L53.6729 55.5303C53.1767 56.0491 53.1767 56.8771 53.6729 57.3964L58.8431 62.6716L64.0355 57.3964C64.5354 56.8771 64.5354 56.0491 64.0355 55.5303L62.2689 53.6642C62.0355 53.4113 61.7022 53.2763 61.3615 53.2958C61.0134 53.2691 60.6689 53.4049 60.4319 53.6642L58.9135 55.2076L57.4172 53.6642C57.158 53.4207 56.8173 53.2886 56.4617 53.2958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.9099,
    cy: 18.3082,
    rx: 17.8471,
    ry: 17.8471,
    fill: "#8C8C8C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10114_14303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white",
    transform: "translate(0.5 0.461182)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduser);
export default __webpack_public_path__ + "static/media/reduser.5105d24daf253ae897de0219f39c1145.svg";
export { ForwardRef as ReactComponent };